<motif-modal-title>
  <h3 class="motif-body1-default-regular m-0">Replicate Deliverable</h3>
  <button type="button" class="modal-close-btn" aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon class="motif-modal-header-close-icon" var='--navigation-Ic-Close-48px' aria-hidden="true"></motif-icon>
  </button>
</motif-modal-title>

<motif-modal-content>
  <div class="right-slide-model-wrapper">
    <div class="d-flex flex-column gap-4 align-items-start justify-content-start">
       <!-- Filing Year Dropdown -->
       <!-- <div class="d-flex flex-column gap-1 align-items-start justify-content-start flex-fill"> -->
        <motif-form-field class="w-100 pe-4">
          <label motifLabel>Compliance Year</label>
          <motif-select 
            labelPosition="inside" 
            aria-label="Select Compliance Year" 
            [(ngModel)]="selectedFilingYear"
            placeholder="Select a Compliance Year"
            (selectionChange)="onSelectFilingYear($event)" 
            aria-required="true" 
            [required]="true">
            <motif-option *ngFor="let year of filingYears" [value]="year">
              {{ year.auditYear}}
            </motif-option>
          </motif-select>
        </motif-form-field>
      <!-- </div> -->

      <!-- Period Dropdown -->
      <div class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel>Compliance Period</label>
          <div class="period-select-with-tooltip">
            <motif-select 
              labelPosition="inside" 
              aria-label="Select Compliance Period" 
              [(ngModel)]="selectedPeriod"
              [sortComparator]="periodSortComparator"
              placeholder="Select Compliance Period"
              (selectionChange)="onSelectPeriod($event)" 
              aria-required="true" 
              [required]="true">
              <motif-option *ngFor="let period of periods" [value]="period">
                {{ period.periodName }}
              </motif-option>
            </motif-select>
            <motif-icon
              [iconFunction]="infoIcon"
              class="period-tooltip-icon"
              [motif-tooltip]="periodTooltip"
              placement="left"
              tabindex="0"
              role="img"
            ></motif-icon>
          </div>
        </motif-form-field>
      </div>
    </div>
  </div>
</motif-modal-content>

<motif-modal-actions>
  <button motifButton motif-modal-close color="secondary" aria-label="Cancel" role="button">
    Cancel
  </button>
  
  <button motifButton color="primary" aria-label="Replicate" 
    (click)="onReplicate()" 
    [disabled]="isReplicateDisabled" 
    role="button">
    Replicate
  </button>
</motif-modal-actions>
